import getVal from './utils/getVal';

export default async function getChild(url, childData, measurements) {
  if (!url || typeof url === 'undefined') return null;
  const data = new URLSearchParams();
  data.append('Sex', getVal(childData.sex));
  data.append('BirthDate', getVal(childData.birthDate));
  data.append('BirthDateYYYY', getVal(childData.birthDateYYYY));
  data.append('BirthDateMM', getVal(childData.birthDateMM));
  data.append('BirthDateDD', getVal(childData.birthDateDD));
  data.append('FatherHeight', getVal(childData.FatherHeight));
  data.append('MotherHeight', getVal(childData.MotherHeight));
  data.append('Title', getVal(childData.title));
  data.append('Comment', getVal(childData.comment));

  for (let i = 0; i < measurements.length; i++) {
    data.append(`Date${i}`, getVal(measurements[i].date));
    data.append(`DateYYYY${i}`, getVal(measurements[i].dateYYYY));
    data.append(`DateMM${i}`, getVal(measurements[i].dateMM));
    data.append(`DateDD${i}`, getVal(measurements[i].dateDD));
    data.append(`Selected${i}`, measurements[i].selected);
    data.append(`Height${i}`, getVal(measurements[i].height));
    data.append(`Weight${i}`, getVal(measurements[i].weight));
  }

  try {
    const response = await fetch(`${url}webcharts.com/child`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: data,
    }).then((res) => res.json());
    return response;
  } catch (error) {
    return null;
  }
}

/* EXAMPLE:
const res = await getChild(
    'https://dev-calculator.morethanheight.com/uk/',
    {
        sex: 'M',
        birthDate: '2015-08-07',
        birthDateYYYY: '2015',
        birthDateMM: '08',
        birthDateDD: '07',
        FatherHeight: 182,
        MotherHeight: 170,
    },
    [
        {
            date: '2020-05-11',
            dateYYYY: '2020',
            dateMM: '05',
            dateDD: '11',
            selected: true,
            height: 110.0,
            weight: 20.0,
        },
        {
            date: '2020-08-11',
            dateYYYY: '2020',
            dateMM: '08',
            dateDD: '11',
            selected: true,
            height: 115.0,
            weight: 22.0,
        },
    ]
);
*/
